import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { EduCategoryService } from 'src/app/service/context/edu/edu-category.service';

@Component({
    selector: 'app-edu-category',
    templateUrl: './edu-category.component.html',
    styles: []
})
export class EduCategoryComponent implements OnInit {
    constructor(
        private eduCategoryService: EduCategoryService,
        private toastr: ToastrService,
        private router: Router
    ) { }

    eduCategories: any[] = [];

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.eduCategories = [];
        this.eduCategoryService.getListEduCategory().subscribe(
            res => {
                let cats = <any>res;

                cats.sort((a, b) => a['treeLevel'] - b['treeLevel'] || <any>new Date(b['createdAt']) - <any>new Date(a['createdAt']));
                for (const catParent of cats.filter(x => !x.guidParent)) {
                    catParent.children = cats.filter((x) => x.guidParent == catParent.guid);

                    for (const menuChild of catParent.children) {
                        menuChild.children = cats.filter((x) => x.guidParent == menuChild.guid);
                    }

                    this.eduCategories.push(catParent);
                }
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onEdit(guid) {
        this.router.navigateByUrl('/techbyte/admin/edu-category/edit/' + guid);
    }

    onRemove(guid) {
        document.getElementById('page-loader-data').style.display = "block";
        this.eduCategoryService.deleteEduCategory(guid).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadData();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }
}